import { render, staticRenderFns } from "./AlarmParam.vue?vue&type=template&id=4385f000&scoped=true&"
import script from "./AlarmParam.vue?vue&type=script&lang=js&"
export * from "./AlarmParam.vue?vue&type=script&lang=js&"
import style0 from "./AlarmParam.vue?vue&type=style&index=0&id=4385f000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4385f000",
  null
  
)

export default component.exports